import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    SearchHeading,
    SearchHeader,
    EmptyBox,
} from './SearchOrdersPanel.styled';
import {
    FilterWrapperMain,
    FilterContentMain,
    Reset,
    TextBold,
    FilterBlock,
} from 'src/common/components/filter/Filters.styled.jsx';
import {
    DetailsMainContainerBlock,
    Title,
} from 'src/pages/orders/components/orderDetails/replenRequest/ReplenRequest.styled';
import { MainContainerItems } from 'src/pages/orders/components/orderDetails/backOrderDetails/BackOrderDetails.styled';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import InputBox from 'src/common/refactoredComponents/input/Input';
import CalendarIcon from 'src/assets/images/CalendarIcon.svg';
import Datepicker from 'src/common/refactoredComponents/datePicker/DatePicker';
import {
    setSearchParams,
    getSearchOrderListData,
    setShowExpandedSearchPanel,
    showHideSearchModalAction,
} from 'src/pages/orders/redux/actions';
import { convertDateToISOString, resumeScrolling } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { ENABLED, VISIBLE } from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const SearchOrdersPanel = ({
    onClose,
    showSearch,
    isOrderResultPopUp = false,
    bannerHeight,
    isOrderHistory = false,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [expandedCard, setExpandedCard] = useState(null);
    const [keyboardPaddingBottom, setKeyboardPaddingBottom] = useState('');
    const { showExpandedSearchPanel } = useSelector(
        (state) => state.orderFilterReducer
    );
    const { sortOrder, sortParam, pageLimit } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );
    const { patientIdVisibility } = useSelector((state) => state.loginReducer);
    useEffectWithErrorLogging(() => {
        initSearchContiner();
        resumeScrolling();
    }, []);

    const initSearchContiner = () => {
        if (showExpandedSearchPanel) {
            setExpandedCard({ ...showExpandedSearchPanel });
        }
    };

    useEffectWithErrorLogging(() => {
        initSearchContiner();
    }, [showExpandedSearchPanel]);

    const [inputFields, setInputFields] = useState({
        account: '',
        hrefId: '',
        physician: '',
        surgeryDate: '',
        networkId: '',
        patientName: '',
        procedure: '',
        lotSerialNumber: '',
        myCaseRef: '',
        sapOrderId: '',
        purchaseOrderId: '',
        unidCaseId: '',
        trackingNumber: '',
        delivery: '',
        secondaryVendorCaseNo: '',
    });

    const toggleCard = (name, value) => {
        setExpandedCard({ ...expandedCard, [name]: value });
    };
    const [showSearchButton, setShowSearchButton] = useState(false);

    const onChangeHandler = (fieldName, value) => {
        if (fieldName === 'surgeryDate') {
            const surgeryDate = convertDateToISOString(new Date(value), 'end');
            setInputFields({
                ...inputFields,
                surgeryDate: surgeryDate,
            });
        } else {
            setInputFields({
                ...inputFields,
                [fieldName]: value,
            });
        }
    };

    const onApplySearchHandler = () => {
        dispatch(showHideSearchModalAction({ showOrdersResult: false }));
        dispatch(
            setSearchParams({
                ...inputFields,
                account: inputFields.account.trim(),
                physician: inputFields.physician.trim(),
                patientName: inputFields.patientName.trim(),
                procedure: inputFields.procedure.trim(),
                delivery: inputFields.delivery.trim(),
            })
        );
        dispatch(
            getSearchOrderListData({
                searchParams: {
                    ...inputFields,
                    account: inputFields.account.trim(),
                    physician: inputFields.physician.trim(),
                    patientName: inputFields.patientName.trim(),
                    procedure: inputFields.procedure.trim(),
                    delivery: inputFields.delivery.trim(),
                },
                pageLimit: pageLimit,
                isActionItem: true,
                pageNo: 0,
                sortOrder: sortOrder,
                sortParam: sortParam,
                  isFromOrderHistory:isOrderHistory,
            })
        );
        dispatch(
            setShowExpandedSearchPanel({
                ...expandedCard,
            })
        );
        onClose();
    };

    useEffectWithErrorLogging(() => {
        if (Object.keys(inputFields).some((key) => inputFields[key] != '')) {
            setShowSearchButton(true);
        } else {
            setShowSearchButton(false);
        }
        if (showSearch) {
            const listener = (event) => {
                if (
                    event.code === 'Enter' ||
                    event.code === 'NumpadEnter' ||
                    event.key === 'Enter'
                ) {
                    event.preventDefault();
                    onApplySearchHandler();
                }
            };
            document.addEventListener('keydown', listener);
            return () => {
                document.removeEventListener('keydown', listener);
            };
        }
    }, [inputFields]);
    const {
        account,
        hrefId,
        physician,
        surgeryDate,
        networkId,
        patientName,
        procedure,
        lotSerialNumber,
        myCaseRef,
        sapOrderId,
        purchaseOrderId,
        unidCaseId,
        trackingNumber,
        delivery,
        secondaryVendorCaseNo,
    } = inputFields;

    const resetHandler = () => {
        setInputFields((inputFields) => ({
            ...inputFields,
            account: '',
            hrefId: '',
            physician: '',
            surgeryDate: '',
            networkId: '',
            patientName: '',
            procedure: '',
            lotSerialNumber: '',
            myCaseRef: '',
            sapOrderId: '',
            purchaseOrderId: '',
            unidCaseId: '',
            trackingNumber: '',
            delivery: '',
            secondaryVendorCaseNo: '',
        }));
    };
    const handleKeyboardOpen = (paddingHeight) => {
        setKeyboardPaddingBottom(paddingHeight);
        const searchBox = document.getElementsByClassName('FilterWrapperMain');
        searchBox.onscroll = function () {
            searchBox.scrollTo(0, searchBox[0].scrollHeight);
        };
    };
    const handleKeyboardClose = (paddingHeight) => {
        setKeyboardPaddingBottom(paddingHeight);
    };
    return (
        <FilterBlock isOrderResultPopUp={isOrderResultPopUp}>
            <FilterWrapperMain
                className="FilterWrapperMain"
                keyboardPaddingBottom={keyboardPaddingBottom}
                isOrderResultPopUp={isOrderResultPopUp}
                bannerHeight={bannerHeight}
            >
                <SearchHeader mobileMarginBottom={'0.3rem'}>
                    <SearchHeading>
                        {t(
                            'orders.orderDetails.shipAndTrack.highlightSearch.search'
                        )}
                    </SearchHeading>
                    <div id="orders-searchorderspanel-reset-button" onClick={resetHandler}>
                        <Reset>{t('orders.searchOrdersPanel.reset')}</Reset>
                    </div>
                </SearchHeader>
                <FilterContentMain>
                    <CollapsableCard id="orders-searchOrdersPanel-searchOrdersPanel-surgeryDetails"
                        title={t('common.surgeryDetails')}
                        onClick={() =>
                            toggleCard(
                                'surgeryDetails',
                                expandedCard?.surgeryDetails !== undefined &&
                                    expandedCard?.surgeryDetails !== null
                                    ? !expandedCard.surgeryDetails
                                    : true
                            )
                        }
                        isExpanded={
                            expandedCard?.surgeryDetails !== undefined &&
                            expandedCard?.surgeryDetails !== null
                                ? expandedCard.surgeryDetails
                                : false
                        }
                        padding={'16px'}
                        margin={'6px 16px 6px 16px'}
                    >
                        {expandedCard?.surgeryDetails &&
                        expandedCard.surgeryDetails ? (
                            <>
                                <DetailsMainContainerBlock>
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t(
                                                'orders.searchOrdersPanel.title'
                                            )}
                                        </Title>
                                        <InputBox
                                            placeholder={t(
                                                'orders.searchOrdersPanel.accountName'
                                            )}
                                            id={'orders-searchOrdersPanel-searchOrdersPanel-accountName'}
                                            value={account}
                                            onChange={(event) =>
                                                onChangeHandler(
                                                    'account',
                                                    event.target.value
                                                )
                                            }
                                        />
                                    </MainContainerItems>
                                        <MainContainerItems
                                            width={'100%'}
                                            marginBottom={'16px'}
                                            ipadPadding={'0rem 0.1rem'}
                                        >
                                            <Title
                                                color={'#202124'}
                                                fontSize={'14px'}
                                                marginBottom={'5px'}
                                            >
                                                {t(
                                                    'orders.searchOrdersPanel.hospitalPatientReferenceID'
                                                )}
                                            </Title>
                                            <InputBox
                                                placeholder={t(
                                                    'orders.searchOrdersPanel.hospitalPatient'
                                                )}
                                                id={'orders-searchOrdersPanel-searchOrdersPanel-hospitalPatient'}
                                                onChange={(event) =>
                                                    onChangeHandler(
                                                        'hrefId',
                                                        event.target.value
                                                    )
                                                }
                                                value={hrefId}
                                            />
                                        </MainContainerItems>
                                    
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t(
                                                'orders.searchOrdersPanel.physician'
                                            )}
                                        </Title>
                                        <InputBox
                                            placeholder={t(
                                                'orders.searchOrdersPanel.enterPhysician'
                                            )}
                                            id={'orders-searchOrdersPanel-searchOrdersPanel-physician'}
                                            onChange={(event) =>
                                                onChangeHandler(
                                                    'physician',
                                                    event.target.value
                                                )
                                            }
                                            value={physician}
                                        />
                                    </MainContainerItems>
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t('common.surgeryDateLabel')}
                                        </Title>
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '40px',
                                            }}
                                        >
                                            <Datepicker
                                            id="orders-searchorderspanel-surgery-date-datepicker"
                                                border={'2px solid #ebeded'}
                                                opacity={'0.7'}
                                                fontSize={'16px'}
                                                datePickerDivMbWidth={'100%'}
                                                datePickerDivMbHeight={'5vh'}
                                                datePopOverZIndex={99999}
                                                onChange={(event) =>
                                                    onChangeHandler(
                                                        'surgeryDate',
                                                        event
                                                    )
                                                }
                                                datePickerCalendarIcon={
                                                    CalendarIcon
                                                }
                                                datePickerDivWidth="100%"
                                                datePickerDivHeight="100%"
                                                  placeholder={t(
                                                'common.surgeryDateLabel'
                                            )}
                                                selectedDateFromDatePicker={
                                                    surgeryDate
                                                }
                                                datePickerBgColor={'#FFFFFF'}
                                                iconHeight={'30px'}
                                                iconPaddingTop={'3%'}
                                                smbWidth={'100%'}
                                                smbIconPaddingTop={'0px'}
                                                smbIconheight={'25px'}
                                                
                                            />
                                        </div>
                                    </MainContainerItems>
                                        <MainContainerItems
                                            width={'100%'}
                                            marginBottom={'16px'}
                                            ipadPadding={'0rem 0.1rem'}
                                        >
                                            <Title
                                                color={'#202124'}
                                                fontSize={'14px'}
                                                marginBottom={'5px'}
                                            >
                                                {t(
                                                    'orders.searchOrdersPanel.NetworkId'
                                                )}
                                            </Title>
                                            <InputBox
                                                placeholder={t(
                                                    'orders.searchOrdersPanel.networkID'
                                                )}
                                                id={'orders-searchOrdersPanel-searchOrdersPanel-networkId'}
                                                onChange={(event) =>
                                                    onChangeHandler(
                                                        'networkId',
                                                        event.target.value
                                                    )
                                                }
                                                value={networkId}
                                            />
                                        </MainContainerItems>
                                    {isOrderHistory && (
                                        <>
                                            <MainContainerItems
                                                width={'100%'}
                                                marginBottom={'16px'}
                                                ipadPadding={'0rem 0.1rem'}
                                            >
                                                <Title
                                                    color={'#202124'}
                                                    fontSize={'14px'}
                                                    marginBottom={'5px'}
                                                >
                                                    {t(
                                                        'orders.searchOrdersPanel.PatientName'
                                                    )}
                                                </Title>
                                                <InputBox
                                                    placeholder={t(
                                                        'orders.searchOrdersPanel.patientName'
                                                    )}
                                                    id={'orders-searchOrdersPanel-searchOrdersPanel-patientName'}
                                                    onChange={(event) =>
                                                        onChangeHandler(
                                                            'patientName',
                                                            event.target.value
                                                        )
                                                    }
                                                    value={patientName}
                                                />
                                            </MainContainerItems>
                                            <MainContainerItems
                                                width={'100%'}
                                                marginBottom={'16px'}
                                                ipadPadding={'0rem 0.1rem'}
                                            >
                                                <Title
                                                    color={'#202124'}
                                                    fontSize={'14px'}
                                                    marginBottom={'5px'}
                                                >
                                                    {t('orders.searchOrdersPanel.Procedure')}
                                                </Title>
                                                <InputBox
                                                    placeholder={t('orders.searchOrdersPanel.procedure')}
                                                    id={'orders-searchOrdersPanel-searchOrdersPanel-procedure'}
                                                    onChange={(event) =>
                                                        onChangeHandler(
                                                            'procedure',
                                                            event.target.value
                                                        )
                                                    }
                                                    value={procedure}
                                                />
                                            </MainContainerItems>
                                        </>
                                    )}
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t(
                                                'orders.searchOrdersPanel.Serial'
                                            )}
                                        </Title>
                                        <InputBox
                                            placeholder={t(
                                                'orders.searchOrdersPanel.serial'
                                            )}
                                            id={'orders-searchOrdersPanel-searchOrdersPanel-lotSerialNumber'}
                                            onChange={(event) =>
                                                onChangeHandler(
                                                    'lotSerialNumber',
                                                    event.target.value
                                                )
                                            }
                                            value={lotSerialNumber}
                                        />
                                    </MainContainerItems>
                                </DetailsMainContainerBlock>
                            </>
                        ) : null}
                    </CollapsableCard>
                    <CollapsableCard id="orders-searchOrdersPanel-searchOrdersPanel-orderNumbers"
                        title={t('orders.searchResultsPanel.orderNumbers')}
                        onClick={() =>
                            toggleCard(
                                'orderNumbers',
                                expandedCard?.orderNumbers !== undefined &&
                                    expandedCard?.orderNumbers !== null
                                    ? !expandedCard.orderNumbers
                                    : false
                            )
                        }
                        isExpanded={
                            expandedCard?.orderNumbers !== undefined &&
                            expandedCard?.orderNumbers !== null
                                ? expandedCard.orderNumbers
                                : false
                        }
                        padding={'16px'}
                        margin={'5px 16px 5px 16px'}
                    >
                        {expandedCard?.orderNumbers &&
                        expandedCard.orderNumbers ? (
                            <>
                                <DetailsMainContainerBlock>
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t(
                                                'orders.searchOrdersPanel.myCaseRef'
                                            )}
                                        </Title>
                                        <InputBox
                                            placeholder={t(
                                                'orders.searchOrdersPanel.myCASEReference'
                                            )}
                                            onChange={(event) =>
                                                onChangeHandler(
                                                    'myCaseRef',
                                                    event.target.value.slice(
                                                        0,
                                                        12
                                                    )
                                                )
                                            }
                                            value={myCaseRef}
                                            id={'orders-searchOrdersPanel-searchOrdersPanel-myCaseRef'}
                                        />
                                    </MainContainerItems>
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t(
                                                'orders.searchOrdersPanel.sapOrder'
                                            )}
                                        </Title>
                                        <InputBox
                                            placeholder={t(
                                                'orders.searchOrdersPanel.SAPOrder'
                                            )}
                                            onChange={(event) =>
                                                onChangeHandler(
                                                    'sapOrderId',
                                                    event.target.value.slice(
                                                        0,
                                                        10
                                                    )
                                                )
                                            }
                                            value={sapOrderId}
                                            id={'orders-searchOrdersPanel-searchOrdersPanel-sapOrderId'}
                                        />
                                    </MainContainerItems>
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t(
                                                'orders.searchOrdersPanel.purchaseOrder'
                                            )}
                                        </Title>
                                        <InputBox
                                            placeholder={t(
                                                'orders.searchOrdersPanel.enterPurchaseOrder'
                                            )}
                                            onChange={(event) =>
                                                onChangeHandler(
                                                    'purchaseOrderId',
                                                    event.target.value
                                                )
                                            }
                                            value={purchaseOrderId}
                                            id={'orders-searchOrdersPanel-searchOrdersPanel-purchaseOrderId'}
                                        />
                                    </MainContainerItems>
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t(
                                                'orders.searchOrdersPanel.unidCase'
                                            )}
                                        </Title>
                                        <InputBox
                                            fontSize={'14px'}
                                            placeholder={t(
                                                'orders.searchOrdersPanel.unidCase'
                                            )}
                                            onChange={(event) =>
                                                onChangeHandler(
                                                    'unidCaseId',
                                                    event.target.value
                                                )
                                            }
                                            value={unidCaseId}
                                            id={'orders-searchOrdersPanel-searchOrdersPanel-unidCaseId'}
                                        />
                                    </MainContainerItems>
                                    <MainContainerItems
                                        width={'100%'}
                                        marginBottom={'16px'}
                                        ipadPadding={'0rem 0.1rem'}
                                    >
                                        <Title
                                            color={'#202124'}
                                            fontSize={'14px'}
                                            marginBottom={'5px'}
                                        >
                                            {t(
                                                'orders.searchOrdersPanel.vendorCase'
                                            )}
                                        </Title>
                                        <InputBox
                                            placeholder={t(
                                                'orders.searchOrdersPanel.vendorCase'
                                            )}
                                            onChange={(event) =>
                                                onChangeHandler(
                                                    'secondaryVendorCaseNo',
                                                    event.target.value
                                                )
                                            }
                                            value={secondaryVendorCaseNo}
                                            id={
                                                'orders-searchOrdersPanel-searchOrdersPanel-secondaryVendorCaseNo'
                                            }
                                        />
                                    </MainContainerItems>
                                </DetailsMainContainerBlock>
                            </>
                        ) : null}
                    </CollapsableCard>
                    {!isOrderHistory && (
                        <CollapsableCard id="orders-searchOrdersPanel-searchOrdersPanel-shipping"
                            title={t(
                                'scheduleSurgery.Shipping.Shipping.shippingTitle'
                            )}
                            onClick={() =>
                                toggleCard(
                                    'shipping',
                                    expandedCard?.shipping !== undefined &&
                                        expandedCard?.shipping !== null
                                        ? !expandedCard.shipping
                                        : false
                                )
                            }
                            isExpanded={
                                expandedCard?.shipping !== undefined &&
                                expandedCard?.shipping !== null
                                    ? expandedCard.shipping
                                    : false
                            }
                            padding={'16px'}
                            margin={'5px 16px 5px 16px'}
                        >
                            {expandedCard?.shipping && expandedCard.shipping ? (
                                <>
                                    <DetailsMainContainerBlock>
                                        <MainContainerItems
                                            width={'100%'}
                                            marginBottom={'16px'}
                                            ipadPadding={'0rem 0.1rem'}
                                        >
                                            <Title
                                                color={'#202124'}
                                                fontSize={'14px'}
                                                marginBottom={'5px'}
                                            >
                                                {t(
                                                    'orders.searchOrdersPanel.carrierTracking'
                                                )}
                                            </Title>
                                            <InputBox
                                                placeholder={t(
                                                    'orders.searchOrdersPanel.placeholder3'
                                                )}
                                                onChange={(event) =>
                                                    onChangeHandler(
                                                        'trackingNumber',
                                                        event.target.value
                                                    )
                                                }
                                                value={trackingNumber}
                                                id={'orders-searchOrdersPanel-searchOrdersPanel-trackingNumber'}
                                                onFocus={() =>
                                                    handleKeyboardOpen('100px')
                                                }
                                                onBlur={() =>
                                                    handleKeyboardClose('0px')
                                                }
                                            />
                                        </MainContainerItems>
                                        <MainContainerItems
                                            width={'100%'}
                                            marginBottom={'16px'}
                                            ipadPadding={'0rem 0.1rem'}
                                        >
                                            <Title
                                                color={'#202124'}
                                                fontSize={'14px'}
                                                marginBottom={'5px'}
                                            >
                                                {t(
                                                    'orders.searchOrdersPanel.Delivery'
                                                )}
                                            </Title>
                                            <InputBox
                                                placeholder={t(
                                                    'orders.searchOrdersPanel.enterDelivery'
                                                )}
                                                onChange={(event) =>
                                                    onChangeHandler(
                                                        'delivery',
                                                        event.target.value
                                                    )
                                                }
                                                value={delivery}
                                                id={'orders-searchOrdersPanel-searchOrdersPanel-delivery'}
                                                onFocus={() =>
                                                    handleKeyboardOpen('150px')
                                                }
                                                onBlur={() =>
                                                    handleKeyboardClose('0px')
                                                }
                                            />
                                        </MainContainerItems>
                                    </DetailsMainContainerBlock>
                                </>
                            ) : null}
                        </CollapsableCard>
                    )}
                    <EmptyBox></EmptyBox>
                    <BottomNavigation
                        justifyContent={'space-evenly'}
                        opacity={'1'}
                        padding={'11px'}
                        position={'absolute'}
                    >
                        <Button
                          id={'orders-searchorderspanel-close-button'}
                            show={true}
                            //secondary={true}
                            variant={ButtonStyles?.secondary}
                            width={'40%'}
                            height={'38px'}
                            clicked={onClose}
                        >
                            <TextBold color={'#1010EB'}>
                                {t('orders.orderListFilters.closeButton')}
                            </TextBold>
                        </Button>
                        <Button
                         id={'orders-searchorderspanel-searchbox-button'}
                            show={true}
                            //primary={showSearchButton}
                            width={'40%'}
                            height={'38px'}
                            disabled={!showSearchButton}
                            variant={showSearchButton ? ButtonStyles?.primary : ButtonStyles?.disabled}
                            clicked={onApplySearchHandler}
                        >
                            <TextBold color={'#FFFF'}>
                                {t('calendar.calendarPanel.searchBox.search')}
                            </TextBold>
                        </Button>
                    </BottomNavigation>
                </FilterContentMain>
            </FilterWrapperMain>
        </FilterBlock>
    );
};

export default SearchOrdersPanel;
